exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-icon{\n    border: none;\n}\n.sub-heading{\n  margin-top: 30px;\n  margin-bottom: -12px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a2c18d3","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard/Views/Configurations/Configurations.vue
// module id = D/Kl
// module chunks = 0